import React from "react";
import "./About.css";
import { useTranslation } from "react-i18next";
import Navbar from "../../components/shared/Navbar/Navbar";
import Footer from "../../components/shared/Footer/Footer";
import AboutHero from "../../components/pages/About/AboutHero/AboutHero";
import OurValues from "../../components/pages/About/OurValues/OurValues";
import OurVision from "../../components/pages/About/OurVision/OurVision";
import Locations from "../../components/pages/About/Locations/Locations";
import HowWeWork from "../../components/pages/About/HowWeWork/HowWeWork";
import AboutServices from "../../components/pages/About/AboutServices/AboutServices";
import AboutStartNewProject from "../../components/pages/About/AboutStartNewProject/AboutStartNewProject";
import Partners from "../../components/pages/About/Partners/Partners";
import { usePageContent } from "../../hooks/usePublicQueries";

const unwrapSectionData = (section) => {
  if (section == null) return section;
  if (typeof section === "string") {
    const t = section.trim();
    if (t.startsWith("{")) {
      try {
        const parsed = JSON.parse(t);
        if (parsed && typeof parsed === "object") return unwrapSectionData(parsed);
      } catch {
        return section;
      }
    }
    return section;
  }
  if (typeof section !== "object") return section;
  if (section.data && typeof section.data === "object") return section.data;
  return section;
};

const normalizeSectionSlug = (key) =>
  String(key || "")
    .toLowerCase()
    .replace(/[_\s-]+/g, "");

const findPageSection = (root, slug) => {
  if (!root || typeof root !== "object") return undefined;
  const target = normalizeSectionSlug(slug);
  const hit = Object.keys(root).find((k) => normalizeSectionSlug(k) === target);
  return hit != null ? root[hit] : undefined;
};

const About = () => {
  const { i18n } = useTranslation();
  const { data: aboutContent } = usePageContent("about", i18n.language);

  return (
    <div className="about-page">
      <Navbar theme="dark" />
      <div className="about-page-content-guide">
        <AboutHero content={unwrapSectionData(findPageSection(aboutContent, "hero"))} />
        <OurValues content={unwrapSectionData(findPageSection(aboutContent, "ourvalues"))} />
        <OurVision content={unwrapSectionData(findPageSection(aboutContent, "ourvision"))} />
        <Locations content={findPageSection(aboutContent, "locations")} />
        {/* <HowWeWork content={findPageSection(aboutContent, "howwework")} /> */}
        <AboutServices
          content={unwrapSectionData(
            findPageSection(aboutContent, "aboutservices") ||
              findPageSection(aboutContent, "ourservices")
          )}
        />
        <AboutStartNewProject
          content={unwrapSectionData(
            findPageSection(aboutContent, "startanewproject") ||
              findPageSection(aboutContent, "aboutstartnewproject")
          )}
        />
        <Partners content={findPageSection(aboutContent, "partners")} />
      </div>
      <Footer />
    </div>
  );
};

export default About;
